
export default {
  name: 'EmptyLayout',
  mounted() {
    this.$nextTick(() => {
      this.$nuxt.$loading.finish()
    })
  }
}
